import { render, staticRenderFns } from "./NvCheckbox.vue?vue&type=template&id=fce2a34c&"
import script from "./NvCheckbox.ts?vue&type=script&lang=ts&"
export * from "./NvCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./NvCheckbox.vue?vue&type=style&index=0&id=fce2a34c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports